import React, { useState } from 'react';
import axios from 'axios';
import { servicios_grupogack_catalogo, registro_no_guardado } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService';

import ModalService from '../../../ModalService/ModalService';
//import AlertForm from '../../../../../../Services/AlertForm';
import FormularioColonias from './FormularioColonias';

const ModalAddColonias = ({ openAdd, setOpenAdd, agregar, errorTable, informacionAdicional, nombreModulo }) => {
    const [ error, setError ] = useState( null );
    const cerrarModal = () => {
        setOpenAdd( false );
        setError( null );
    }

    const enviarColonia = ( colonia ) => {
        console.log( colonia );
        axios.post( `${servicios_grupogack_catalogo}s/colonias/${informacionAdicional.postalCode}`, colonia, headersAuth() )
            .then( respuesta => {
                //console.log( respuesta );
                switch( respuesta.data.status ){
                    case 200:
                        agregar( respuesta.data.dataResponse );
                        setOpenAdd( false );
                        break;
                    default:
                        errorTable( registro_no_guardado );
                        break;
                }
            })
            .catch( error => {
                errorTable( registro_no_guardado );
            })
    }

    return (
        <ModalService title="Nueva Colonia" parentNode={nombreModulo} minWidth="40%"
            isOpen={ openAdd } onClose={ () => cerrarModal() } >
                <FormularioColonias
                    error={error}
                    enviarColonia={enviarColonia}
                    informacion={informacionAdicional}
                />
        </ModalService>
    );
};

export default ModalAddColonias;